import { BoxInjectionService } from './box-injection.service';

export default angular
  .module('sfMobile.services.box-injection', [])
  .service('boxInjectionService', BoxInjectionService).name;
